export default function AttachAgendaItemReportDirective() {
  return {
    template: require('./attach-agendaItem-report.html'),
    scope: {
      agendaItemId: '=',
      serviceId: '=',
      reportId: '=',
      report: '=',
    },
    controller: 'AttachAgendaItemReportController',
    controllerAs: 'attachAgendaItemReportVM',
    bindToController: true,
    replace: true
  };
}
